import request from '@/utils/request'

// 查询银河打本开本优惠券列表
export function listShopCoupon(query) {
  return request({
    url: '/played/shop/coupon/list',
    method: 'get',
    params: query
  })
}

// 查询银河打本开本优惠券列表
export function pageShopCoupon(query) {
  return request({
    url: '/played/shop/coupon/pageShopCoupon',
    method: 'get',
    params: query
  })
}

// 查询银河打本开本优惠券详细
export function getShopCoupon(id) {
  return request({
    url: '/played/shop/coupon/' + id,
    method: 'get'
  })
}

// 新增银河打本开本优惠券
export function addShopCoupon(data) {
  return request({
    url: '/played/shop/coupon',
    method: 'post',
    data: data
  })
}

// 修改银河打本开本优惠券
export function updateShopCoupon(data) {
  return request({
    url: '/played/shop/coupon',
    method: 'put',
    data: data
  })
}

// 删除银河打本开本优惠券
export function delShopCoupon(id) {
  return request({
    url: '/played/shop/coupon/' + id,
    method: 'delete'
  })
}

// 给三方申领发放优惠券
export function issueThirtyCoupons(data) {
  return request({
    url: '/played/shop/coupon/issue/thirty',
    method: 'post',
    data: data
  })
}

// 给店铺发放优惠券
export function issueShopCoupons(data) {
  return request({
    url: '/played/shop/coupon/issue/shop',
    method: 'post',
    data: data
  })
}
